/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerBlockElements.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Block Elements
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, October 01, 2018 - 05:25:15 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      10/01/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    BLOCKELEMENT_ADD,
    BLOCKELEMENT_EDIT,
    BLOCKELEMENT_DELETE,
    BLOCKELEMENT_OPEN_WARNING,
    BLOCKELEMENT_CLOSE_WARNING,

    BLOCKELEMENT_EDIT_CONTAINER_LOADED,
    BLOCKELEMENT_EDIT_CONTAINER_UNLOADED,
    BLOCKELEMENT_EDIT_FORM_LOADED,
    BLOCKELEMENT_EDIT_FORM_UNLOADED,

    BLOCKELEMENT_UPDATE_VALUE,
    BLOCKELEMENT_SET_ELEMENTTYPE_SELECT,
    BLOCKELEMENT_SET_DATATYPE_SELECT,
    BLOCKELEMENT_EDIT_DATA_LOAD,
    BLOCKELEMENT_EDIT_ELEMENTOPTIONS_LOAD,
    BLOCKELEMENT_EDIT_ELEMENTOPTIONS_DRAW,
    BLOCKELEMENT_EDIT_VALIDATIONTYPES_LOAD,
    BLOCKELEMENT_EDIT_VALIDATIONTYPES_DRAW,
    BLOCKELEMENT_EDIT_FIELDSETGROUPS_LOAD,
    BLOCKELEMENT_EDIT_FIELDSET_LOADED,
    BLOCKELEMENT_UPDATE_FIELD,

    BLOCKELEMENT_EDIT_CONTAINER_SUBMIT,
    BLOCKELEMENT_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeBlockElements';

const defaultState = {
    refreshList: false,
    danger: false,
    blockelementid: 0,
    blockgroupid: 0,
    blockid: 0,
    blockelementtypeid: 0,
    name: '',
    label: '',
    description: '',
    datatypeid: 0,
    activeid: 0,
    shortkey: '',
    fieldsetgroupid: 0,
    fieldsetid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case BLOCKELEMENT_ADD:
            return {
                ...state
            }
        case BLOCKELEMENT_EDIT:
            return {
                ...state,
                blockelementid: action.id
            }
        case BLOCKELEMENT_DELETE:
            return {
                ...state,
                blockelementid: null
            }
        case BLOCKELEMENT_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case BLOCKELEMENT_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case BLOCKELEMENT_UPDATE_VALUE:
            return {
                ...state,
                [action.key]: action.value
            }
        case BLOCKELEMENT_SET_ELEMENTTYPE_SELECT:
            return {
                ...state,
                elementTypeOptions: action.payload ? action.payload : []
            }
        case BLOCKELEMENT_SET_DATATYPE_SELECT:
            return {
                ...state,
                dataTypeOptions: action.payload ? action.payload : []
            }
        case BLOCKELEMENT_EDIT_CONTAINER_LOADED:
        case BLOCKELEMENT_EDIT_DATA_LOAD:
            const newResult = {
                ...state,
                listSelect: action.payload[2] ? action.payload[2].records : [],
                blockelementid: action.payload[0] ? action.payload[0].blockelementid : 0,
                blockgroupid: action.payload[0] ? action.payload[0].blockgroupid : 0,
                blockid: action.payload[0] ? action.payload[0].blockid : 0,
                blockelementtypeid: action.payload[0] ? action.payload[0].blockelementtypeid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                label: action.payload[0] ? action.payload[0].label : '',
                description: action.payload[0] ? action.payload[0].description : '',
                datatypeid: action.payload[0] ? action.payload[0].datatypeid : 0,
                activeid: action.payload[0] ? action.payload[0].activeid : 0,
                shortkey: action.payload[0] ? action.payload[0].shortkey : '',
                fieldsetgroupid: action.payload[0] ? action.payload[0].fieldsetgroupid : 0,
                fieldsetid: action.payload[0] ? action.payload[0].fieldsetid : 0,
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
            if (action.payload[0] && action.payload[0].elementOptions && action.payload[0].elementOptions.length > 0) {
                action.payload[0].elementOptions.forEach((element) => {
                    newResult['val_' + element.blockelementoptionid] = element.displayvalue;
                });
            }
            if (action.payload[0] && action.payload[0].validationTypes && action.payload[0].validationTypes.length > 0) {
                action.payload[0].validationTypes.forEach((element) => {
                    newResult['valid_' + element.validationtypeid] = element.activeid;
                });
            }
            if (action.payload[0] && action.payload[0].validationTypeFields && action.payload[0].validationTypeFields.length > 0) {
                action.payload[0].validationTypeFields.forEach((element) => {
                    newResult['validfield_' + element.validationtypefieldid] = element.displayvalue;
                });
            }
            return newResult;

        case BLOCKELEMENT_EDIT_ELEMENTOPTIONS_LOAD:
            return {
                ...state,
                elementoptions: action.payload ? action.payload : []
            }
        case BLOCKELEMENT_EDIT_ELEMENTOPTIONS_DRAW:
            return {
                ...state,
                elementoptionshtml: action.payload ? action.payload : []
            }
        case BLOCKELEMENT_EDIT_VALIDATIONTYPES_LOAD:
            return {
                ...state,
                validationtypes: action.payload ? action.payload : []
            }
        case BLOCKELEMENT_EDIT_VALIDATIONTYPES_DRAW:
            return {
                ...state,
                validationtypeshtml: action.payload ? action.payload : []
            }
        case BLOCKELEMENT_EDIT_FIELDSETGROUPS_LOAD:
            var fsg1 = [{
                'title': 'Please Select A Field Set Group',
                'value': 0,
                'key': 0,
                'disabled': false
            }]
            var fsg2 = action.payload ? action.payload.records : []
            var fieldsetgroups = fsg1.concat(fsg2);

            return {
                ...state,
                fieldsetgroups: fieldsetgroups
            }
        case BLOCKELEMENT_EDIT_FIELDSET_LOADED:
            return {
                ...state,
                fieldsets: action.payload[0] ? action.payload[0].records : null
            }
        case BLOCKELEMENT_UPDATE_FIELD:
            return {
                ...state, [action.key]: action.value
            };
        case BLOCKELEMENT_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case BLOCKELEMENT_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case BLOCKELEMENT_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case BLOCKELEMENT_EDIT_CONTAINER_UNLOADED:
        case BLOCKELEMENT_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerBlockElements.js